import axios from "axios";
import { Component } from "react";
import BaseWebService from "./base_web_service";

class AuthWebService extends Component {
  
  static async getAuthAccessToken() {
    let resp = await axios.post(
      `dev-fx6y84un.us.auth0.com`,
      {
        grant_type: 'client_credentials',
        client_id: 'kjhur8OUWOOcZlyId89qPuYxJKTt9NYU',
        client_secret: 'V-MgqxoMVuD1E4pZAMDPC6aoCu3C-miX001v52yV814_tr6lMYu0bcea5WBwg0Y3',
        audience: 'https://dev-fx6y84un.us.auth0.com/api/v2/'
      },
      {
        headers: {'content-type': 'application/x-www-form-urlencoded'}
      }      
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async login(token,idToken) {
    let resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/localAuth/login`,
      {
        auth0AccessToken: token,
        auth0IdToken:idToken,        
        system: process.env.REACT_APP_BASE_SYSTEM ,        
      }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async resetPassword(userName, password) {
    let resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/localAuth/resetPassword`,
      {
        userName: userName,
        passwordAnswer: password,
      }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async changePassword(userName, oldPassword, password) {
    let headers = await BaseWebService.headers();
    let resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/localAuth/changePassword`,
      {
        oldPassword: oldPassword,
        newPassword: password,
        userName: userName,
      },
      { headers: headers }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
  
  static async logOutPortal() {
    let headers = await BaseWebService.headers();
    let resp = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/localAuth/logout`,
      { headers: headers }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async renewToken(renewToken) {
    let headers = await BaseWebService.fixedHeaders();
    let resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/localAuth/renewJwtToken`,
      {
        renewTokenStr: renewToken,
      },
      { headers: headers }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
}

export default AuthWebService;
